import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from "@jti/store";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { DEPRECATED_Typography as Typography, replaceStringPlaceholder, useIntlNumberFormat, useTranslations, validateLimitedTimeBadgesData, VirtualPrizeBadges, } from "@jti/ui";
import { ImageInfoBanner } from "../../image-info-banner/ImageInfoBanner";
import { PointsProgressBar } from "../../points-progress-bar/PointsProgressBar";
import { getPrizeColor, isLimitedOfferEnabled, validateTierRestriction } from "../util/simplifedPrizesUtils";
import styles from "./ItemsList.module.scss";
export const ItemsList = ({ items, pointsLabel, ctaLabel, noOffersText, earnPointsCtaText, earnPointsCtaUrl, color, points, setDialogData, newBadgeData, limitedOfferLabels, tier, outOfStockLabel, isLogged, }) => {
    const intl = useIntlNumberFormat();
    const isRestricted = useSelector((state) => state.loyaltyCore.isRestricted);
    const shouldHideButton = !isLogged || isRestricted;
    const { __ } = useTranslations();
    const handleOnClick = (item) => {
        setDialogData(item);
        dispatchTrackingEvent(TrackingEvents.TrackingRedeemClick, { reward: item.name });
    };
    return items.length > 0 ? (_jsx("div", { className: styles.itemsList, "data-testid": "simplifiedPrizes", children: items.map((item, index) => {
            const hasLimitedOfferBadge = isLimitedOfferEnabled(item.time_to, limitedOfferLabels);
            const prizeColor = getPrizeColor(color, item.color);
            const isTierRestricted = validateTierRestriction(tier, item.levels);
            const { isNewBadgeVisible, isMoreThanOneDay, limitedTimeOfferLabel } = validateLimitedTimeBadgesData({
                newOfferDays: newBadgeData.newOfferDays,
                timeFrom: item.time_from,
                timeTo: item.time_to,
                daysLabel: limitedOfferLabels.daysLabel,
                oneDayLabel: limitedOfferLabels.oneDayLabel,
            });
            const lowestEligibleTier = item.levels?.[0];
            const isOutOfStock = item.has_coupons === false;
            const isEarnPointCtaDisplayed = item.points > points;
            const missingPoints = item.points - points;
            const cta = isEarnPointCtaDisplayed
                ? {
                    label: replaceStringPlaceholder(earnPointsCtaText, [
                        {
                            placeholder: "missingPoints",
                            value: intl.format(missingPoints),
                        },
                    ], false),
                    onClick: () => (window.location.href = earnPointsCtaUrl),
                }
                : { label: ctaLabel, onClick: () => handleOnClick(item) };
            return (_jsx(ImageInfoBanner, { hasGradient: true, hideButton: shouldHideButton || isOutOfStock, disableButton: points >= item.points && isTierRestricted, title: __(item.name), subtitle: __(item.subtitle), text: intl.format(item.points) + " " + pointsLabel, bottomText: cta.label, backgroundImageSrc: item.images[0], color: prizeColor, onClick: cta.onClick, isPrizes: true, pointsProgressBar: _jsx(PointsProgressBar, { hidden: !isLogged, requiredPoints: item.points, currentPoints: points }), children: _jsx(VirtualPrizeBadges, { showNewBadge: isNewBadgeVisible, isTierRestricted: isTierRestricted || !isLogged, tier: lowestEligibleTier, isOutOfStock: isOutOfStock, hasLimitedOfferBadge: hasLimitedOfferBadge, newBadgeLabel: newBadgeData.label, timeLimitedBadgeLabel: limitedTimeOfferLabel, isMoreThanOneDay: isMoreThanOneDay, color: color, outOfStockLabel: outOfStockLabel }) }, `${item.name}_${index}`));
        }) })) : (_jsx(Typography, { type: "title", color: "black", children: noOffersText }));
};
export default ItemsList;
//# sourceMappingURL=ItemsList.js.map